import { Link } from 'react-router-dom';
import { getHotPosts } from '@/mocks/posts';

export default function HotTopics() {
  const hotPosts = getHotPosts();

  return (
    <aside>
      <div className="bg-background-100 rounded-xl p-5">
        <div className="flex items-center gap-2 mb-5">
          <div className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center">
            <i className="ri-fire-line text-xs text-white w-3 h-3 flex items-center justify-center"></i>
          </div>
          <h3 className="font-heading font-bold text-foreground-950">热门话题</h3>
        </div>
        <div className="space-y-4">
          {hotPosts.map((post, index) => (
            <Link
              key={post.id}
              to={`/article/${post.slug}`}
              className="flex gap-3 group cursor-pointer"
            >
              <span className={`text-lg font-bold flex-shrink-0 w-6 ${
                index === 0 ? 'text-accent-500' : 'text-foreground-300'
              }`}>
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="min-w-0">
                <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {post.title}
                </h4>
                <p className="text-xs text-foreground-400 mt-1">
                  {post.likes.toLocaleString()} 人喜欢
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}